import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import "../../assets/css/post/post.css";
import CommentCard from './comments';

import { Link, NavLink } from 'react-router-dom';

import { BiUpvote, BiSolidUpvote } from "react-icons/bi";
import { BiDownvote, BiSolidDownvote } from "react-icons/bi";
import { FaRegBookmark, FaBookmark, FaShare } from "react-icons/fa";
import "../../assets/css/post/comments.css";

// Modals
import DonorsModal from '../../modals/post/DonorsModal';
import ReportModal from '../../modals/post/ReportModal';
import SupportSeekerModal from '../../modals/post/SupportSeekerModal';
import ViewDocument from '../../modals/post/ViewDocument';

// Hooks 
import useDonorsModal from '../../hooks/post/useDonorsModal';
import useReportModal from '../../hooks/post/useReportModal';

import useSupportSeekerModal from '../../hooks/post/useSupportSeekerModal';
import useViewDocumentModal from '../../hooks/post/useViewDocumentModal';
import { Loading } from '../../components/Loading';
import useDeleteModal from '../../hooks/useDeleteModal';
import { useGetPostDetailQuery, useGetPostDocFilesQuery, 
        useDownvoteMutation, useUpvoteMutation, useCommentMutation, useGetCommentsQuery } from '../../services/postApis';

import { useTranslation } from 'react-i18next';
import ShowJoinDonorCommunityModal from '../../modals/post/ShowJoinCommunityModal';
import useShowJoinComHook from '../../hooks/post/useShowJoinCommunity';
import axios from 'axios';
import useCreateUpdatePost from '../../hooks/post/useCreateUpdatePost';
import FlexibleVideoDisplay from './video-display';
import SeekerDetailsTable from './seeker-detail-table';
import { FiAlertTriangle } from "react-icons/fi";


const PostDetailView = () => {

  const { slug } = useParams();
  const { data, isError, error, isLoading } = useGetPostDetailQuery(slug);
  const { data: docData } = useGetPostDocFilesQuery(slug);
  const uDonorsModal = useDonorsModal();
  const uReportModal = useReportModal();
  const { openUpdate } = useCreateUpdatePost();
  
  
  const uSupportSeekerModal = useSupportSeekerModal();
  const uViewDocumentModal = useViewDocumentModal();
  const uShowJoinComModal = useShowJoinComHook();
  const uDeleteModal = useDeleteModal()


  const [upvote, setUpvotes] = useState(0)
  const [downvote, setDownvote] = useState(0)
  const [isUpvoted, setIsUpvoted] = useState(false);
  const [isDownvoted, setIsDownvoted] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [commentList, setCommentList] = useState([]);
  const { data: commentData } = useGetCommentsQuery(slug);
  const [commentCount, setCommentCount] = useState(0);
  const [isDonor, setIsDonor] = useState(false)
  const [isCreator, setIsCreator] = useState(false)
  const [commentErrorMessage, setCommentErrorMessage] = useState('')
  const [showShareTooltip, setShowShareTooltip] = useState(false);
  const [isCommentFocused, setIsCommentFocused] = useState(false);

  const {t} = useTranslation('post')
  const translation = t('detail-page')
  const update_translation = t("post-update")

  const [selectedDoc, setSelectedDoc] = useState(null);
  const [selectedDocName, setSelectedDocName] = useState('')
  const openDocumentModal = (docKey) => {
    setSelectedDoc(docData.documents[docKey]);
    console.log("docData.documents[docKey]", docData.documents[docKey])
    setSelectedDocName(docKey.split("_").join(" "))
    uViewDocumentModal.open();
  };


  useEffect(() => {
    if (data) {
      setUpvotes(data.upvote_count);
      setDownvote(data.downvote_count);
      setIsUpvoted(data.is_upvoted);
      setIsDownvoted(data.is_downvoted);
      setIsSaved(data.is_saved);
      setCommentCount(data.comment_count);
  
      setIsCreator(data.is_creator_access)
      setIsDonor(data.is_viewer_donor || data.is_creator_access);
    }
  }, [data]);

  useEffect(() => {
    if (commentData) {
      setCommentList(commentData);
    }
  }, [commentData]);

  const [upvoteMutation]   =   useUpvoteMutation()
  const [downvoteMutation] =   useDownvoteMutation()
  const [commentMutation]  =   useCommentMutation()

  const handleUpvote = (event) => {
    event.stopPropagation();

    if (!isDonor) {
      uShowJoinComModal.open()
      return
    }

    if (!isUpvoted) {
      setUpvotes(upvote + 1)
      setIsUpvoted(true)
      if (isDownvoted) {
        setDownvote(downvote - 1)
        setIsDownvoted(false)
      };
      upvoteMutation(slug)
    } else {
      setUpvotes(upvote - 1)
      setIsUpvoted(false)
      upvoteMutation(slug)
    }
  }

  const handleDownvote = (event) => {
    event.stopPropagation();

    if (!isDonor) {
      uShowJoinComModal.open()
      return
    }

    if (!isDownvoted) {
      setDownvote(downvote + 1)
      setIsDownvoted(true)
      if (isUpvoted) {
        setUpvotes(upvote - 1)
        setIsUpvoted(false)
      };
      downvoteMutation(slug)
    } else {
      setDownvote(downvote - 1)
      setIsDownvoted(false)
      downvoteMutation(slug)
    }
  }

  const handleSave = async (event) => {
    
    const formData = new FormData();
    formData.append("slug", slug);

    try {
      const newSaveState = !isSaved
      setIsSaved(newSaveState)
      formData.append('save', newSaveState)
      await axios.post(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/post/save-post/`,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            'Content-Type': 'multipart/form-data'
          }
        }
      );
    }catch (error){
      setIsSaved((prev)=> !prev)
    }
  }

  const handleSubmitComment = async (event) => {

    event.preventDefault();
    
    if (!isDonor) {
      setCommentErrorMessage(`${translation.only_donor_comment}`)
      return;
    }

    const formData = new FormData();

    if (event.target.body.value <= 2) {
      setCommentErrorMessage(`${translation.comment_limit_msg}`);
      return;
    }

    formData.append("body", event.target.body.value);
    formData.append("slug", event.target.slug.value);

    try {
      const response = await commentMutation(formData);

      if (response?.error) {
        if (response?.error?.data?.detail) {
          setCommentErrorMessage(response?.error?.data?.detail);
        } else if (response?.error?.data?.error){
          setCommentErrorMessage(response?.error?.data?.error);
        }
      } 

      if (response?.data){
        setCommentErrorMessage('')
        setCommentList([...commentList, response.data]);
        setCommentCount(commentCount + 1);
        event.target.reset();

      }

    } catch (error) {
      setCommentErrorMessage(`${translation.something_wrong}`)
    }
  };

  const handleOpenDocument = (docKey) => {
    if (!isDonor) {
      uShowJoinComModal.open()
      return;
    }
  
    openDocumentModal(docKey);
  };
  
  // Replace the current copyPageUrl function with this improved version
  const copyPageUrl = () => {
    const url = `${process.env.REACT_APP_DOMAIN}/detail/${slug}`;
    navigator.clipboard.writeText(url)
      .then(() => {
        // Show tooltip/notification
        setShowShareTooltip(true);
        
        // Hide tooltip after 2 seconds
        setTimeout(() => {
          setShowShareTooltip(false);
        }, 2000);
      })
      .catch(err => {
        console.error(`${translation.not_copy_url}`, err); 
      });
  };
  
  const handleDeleteComment = (id) => {
    setCommentList((prev) => prev.filter((c) => c.id !== id));
  };

  const handleUpdateComment = (id, newBody) => {
    setCommentList((prev) =>
      prev.map((c) => (c.id === id ? { ...c, body: newBody } : c))
    );
  };

  if (isLoading) {
    return <div><Loading /></div>;
  }
  if (isError) return <div>Error: {error.message}</div>;
  
  return (
    <>
      <Helmet>
        <title>{`Help ${data.seeker.name} with ${data.need} in ${data.seeker.country} | Addazakat`}</title>
        <meta name="description" content={`Support ${data.seeker.name}'s ${data.need_type} for ${data.need_for}. ${data.description?.substring(0, 150)}...`} />
        <link rel="canonical" href={window.location.href} />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="article" />
        <meta property="og:title" content={`Help ${data.seeker.name} with ${data.need}`} />
        <meta property="og:description" content={data.description?.substring(0, 300)} />

        {/* Schema.org structured data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            "headline": data.need_for,
            "description": data.description,
            "datePublished": data.created,
            "author": {
              "@type": "Person",
              "name": data.seeker.creator_fullname
            },
            "articleBody": data.description,
            "keywords": `${data.need}, ${data.post_type}, Zakat, Donation, ${data.seeker.country}, Charity`
          })}
        </script>
      </Helmet>
    
      <div className='bg-white dark:bg-gray-700 text-dark-1 dark:text-gray-100 mt-12 md:m-12 md:max-w-7xl p-5'>
        
        {data.is_deleted && (
          <div className="flex items-center gap-2 my-4 p-3 bg-rose-100 border-l-4 border-rose-500 text-rose-700 rounded">
            <FiAlertTriangle className="flex-shrink-0 h-5 w-5" />
            <span className="font-medium">{translation.post_deleted_msg}</span>
          </div>
        )}

        <FlexibleVideoDisplay
          data={data} 
          isDonor={isDonor} 
          isCreator={isCreator} 
          translation={translation} 
        />

        
        <hr className='m-3' />

        <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>

          <div className='flex space-x-4 md:space-x-5'>

            <Link className='custom-link'
              to={`/profiles/${data.seeker.creator}`}>
              <p className=' border border-blue-400 border-b-2 dark:border-blue-400 hover:bg-blue-200 dark:hover:bg-blue-800  font-bold p-1 rounded-lg text-xs md:text-base'>{translation.creator} {data.seeker.creator_fullname}</p>
            </Link>
            
            <Link className='custom-link' onClick={handleUpvote}>
              {isUpvoted ? <BiSolidUpvote className='text-xl text-green-500' /> : <BiUpvote className='text-xl' />}
              <p className='text-xs font-bold text-blue-500 md:text-base'>{upvote}</p>
            </Link>

            <Link className='custom-link' onClick={handleDownvote}>
              {isDownvoted ? <BiSolidDownvote className='text-xl' /> : <BiDownvote className='text-xl' />}
              <p className='text-xs font-bold text-blue-500 md:text-base'>{downvote}</p>
            </Link>

            <Link className='custom-link' onClick={handleSave}>
              {isSaved ? <FaBookmark className='text-xl' /> : <FaRegBookmark className='text-xl' />}
            </Link>

            <button 
              className="custom-link relative flex items-center space-x-1" 
              onClick={copyPageUrl}
              aria-label="Share post"
            >
              <FaShare className="text-xl hover:text-blue-500 transition-colors" />
              {showShareTooltip && (
                <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-green-600 font-bold text-white text-xs py-1 px-2 rounded shadow-lg">
                  {translation.url_copied }
                </div>
              )}
            </button>

          </div>

          <div className="flex text-xs justify-center m-3 md:text-base gap-1">
            
            {isCreator && (
                <button
                  onClick={()=>{openUpdate(data, docData)}}
                  className="update-btn"
                >
                  {update_translation.modal_name}
                </button>
            )}

            {isCreator && (
                <button
                  onClick={()=>
                    {
                      uDeleteModal.open({
                        endpoint: "/post/delete-object/",
                        payload: { id: data.id, model: "post" },
                        messages: {
                          heading: `${translation.delete_comment_heading}`,
                          message: `${translation.msg} "${data.description.slice(0,15)}"?`,
                          warning: `${translation.warning_msg}`,
                          success: `${translation.success_msg}`,
                          error: `${translation.error_msg}`,
                          cancel: `${translation.cancel}`,
                          confirm: `${translation.delete}`,
                        },
                      });
                    }}
                  className="delete-btn"
                >
                  {update_translation.delete_modal_name}
                </button>
            )}

            <button
              onClick={uDonorsModal.open}
              className="list-btn"
            > 
              {data.donors_count > 0 ? (
                <>
                  {translation.donors} ({data.donors_count})
                </>
              ) : (
                <>{translation.donors}</>
              )}
            </button>

            <button
              onClick={uReportModal.open} 
              className="report-btn">

              {translation.report > 0 ? (
                <>
                  {translation.report} ({data.report_count})
                </>
              ) : (
                <>{translation.report}</>
              )} 
            </button>

            <button
              onClick={uSupportSeekerModal.open} 
              className="update-btn">
              {translation.support_btn}
            </button>
          </div>

          {/* Render the Donate Modal */}
          <DonorsModal slug={data.slug} />
          <ReportModal slug={data.slug} isDonor={isDonor} />
          <SupportSeekerModal slug={data.slug} isDonor={isDonor}/>

        </div>
        
        <hr className='m-3' />

        
          
        <SeekerDetailsTable translation={translation} data={data} isDonor={isDonor} />

        <hr className='m-3' />
        
        <div className="space-y-3 py-4">
          <h2 className="text-2xl font-semibold">{translation.seeker_details.address}</h2>
          <p>{data.seeker.address}</p>
        </div>

        <div className="space-y-3 py-4">
          <h2 className="text-2xl font-semibold">{translation.documents}</h2>
          {!docData && 
            <div>
              {translation.only_donor_doc} <NavLink to="/donor-community" className="text-blue-600 hover:underline dark:text-blue-400">
                          {translation.join_now}
                        </NavLink>
            </div>
          }

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {docData &&
              docData.documents &&
              Object.keys(docData.documents).map((docKey, index) => (
                <button
                  key={docKey}
                  id={index}
                  onClick={() => handleOpenDocument(docKey)}
                  className="flex items-center bg-blue-600 hover:bg-slate-300 text-white font-bold py-1 px-2 rounded-lg mx-2 hover:text-black truncate"
                >
                  {docKey.split("_").join(" ")}
                </button>
              ))}
          </div>

          {uViewDocumentModal.isOpen && <ViewDocument url={selectedDoc} name={selectedDocName} />}
        </div>
        

        <div className='space-y-3 py-4'>
          <div className='text-2xl font-bold'>{translation.discription}</div>
          <p className='text-dark-1 dark:text-white'>{data.description} </p>
        </div>

        <hr className='m-3' />
        
        <div className='py-6 '>
          <p className='text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-6'>{commentCount} {translation.comments}</p>
          
          <form onSubmit={handleSubmitComment} className="mb-8">
            <div className="space-y-4">
              <div className={`
                relative border rounded-lg transition-all duration-200 ease-in-out
                ${isCommentFocused 
                  ? 'border-blue-500 dark:border-blue-400 shadow-lg ring-2 ring-blue-500/20 dark:ring-blue-400/20' 
                  : 'border-gray-400 dark:border-gray-300 hover:border-gray-900 dark:hover:border-gray-100'
                }
                bg-gray-50 dark:bg-gray-700
              `}>
                <textarea
                  id="comment"
                  name="body"
                  rows={isCommentFocused ? "3" : "1"}
                  onFocus={() => setIsCommentFocused(true)}
                  className="w-full px-4 py-3 bg-transparent text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 resize-none border-none outline-none transition-all duration-200"
                  placeholder={translation.add_a_comment}
                />
              </div>
              
              <input type='hidden' value={data.slug} name='slug' />
              
              {isCommentFocused && (
                <div className="flex justify-end space-x-3 pt-2">
                  <button
                    type="button"
                    onClick={() => setIsCommentFocused(false)}
                    className="cancel-btn"
                  >
                    {translation.cancel}
                  </button>
                  <button 
                    type="submit" 
                    className="update-btn"
                  >
                    {translation.comment_sub}
                  </button>
                </div>
              )}
              
              {commentErrorMessage && (
                <div className="mt-2 p-3 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
                  <p className="text-sm text-red-600 dark:text-red-400">{commentErrorMessage}</p>
                </div>
              )}
            </div>
          </form>
          
          <div className="space-y-4">
            {commentList && commentList.length > 0 ? (
              [...commentList].reverse().map(comment => (
                <CommentCard
                  key={comment.id}
                  comment={comment}
                  postId={data.id}
                  onDelete={handleDeleteComment}
                  onUpdate={handleUpdateComment}
                />
              ))
            ) : (
              <div className="text-center py-8">
                <p className="text-gray-500 dark:text-gray-400 text-lg">{translation.no_comment_yet}</p>
              </div>
            )}
          </div>
          
          <ShowJoinDonorCommunityModal hook={uShowJoinComModal} translation={translation}/>
        </div>

      </div>

    </>
    
  );
}

export default PostDetailView
